export default {
  getMixed: (compressedParams, axios) => {
    return axios.get(`/data_api/list/mixed`, { params: {...compressedParams, addRequest: false } })
  }
}